export default __webpack_public_path__ + "static/media/Pokecomp.ca0483ff.PNG";